module.exports = __webpack_public_path__ + "img/MiddleSide_Left.1e241e32.jpg";